import { RotationBerthCallBM } from 'src/types/BusinessModel/Stowage/Rotation/RotationBerthCallBM';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { createRotationCargoOperationList } from './RotationCargoOperationFactory';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';

export const createRotationBerthCall = (rotationBerthCallBM: RotationBerthCallBM, rotationPortCall: RotationPortCall): RotationBerthCall => {
    const berthCall: RotationBerthCall = {
        berthCallGuid: crypto.randomUUID(),
        portCallGuid: rotationPortCall.portCallGuid,
        imosBerthCallId: rotationBerthCallBM.berthCallId > 0 ? rotationBerthCallBM.berthCallId : -rotationPortCall.imosPortCallId,
        dataSource: rotationBerthCallBM.dataSource,
        berthSequenceNumber: rotationBerthCallBM.berthSequenceNumber,
        berthId: rotationBerthCallBM.berthId,
        cargoOperations: null,
        portCall: rotationPortCall,
    };

    berthCall.cargoOperations = createRotationCargoOperationList(rotationBerthCallBM.cargoOperations, berthCall);
    return berthCall;
};

export const createTransitBerthCall = (rotationPortCall: RotationPortCall): RotationBerthCall => {
    const transitBerthCall: RotationBerthCall = {
        berthCallGuid: crypto.randomUUID(),
        portCallGuid: rotationPortCall.portCallGuid,
        imosBerthCallId: null,
        dataSource: 'OrcaWeb',
        berthSequenceNumber: 1000,
        berthId: -1,
        cargoOperations: [],
        portCall: rotationPortCall,
    };

    return transitBerthCall;
};

export const createRotationBerthCallList = (
    rotationBerthCallList: RotationBerthCallBM[],
    rotationPortCall: RotationPortCall
): RotationBerthCall[] => {
    const berthCalls = rotationBerthCallList.map((rotationBerthCall) => createRotationBerthCall(rotationBerthCall, rotationPortCall));
    const transitBerthCall = createTransitBerthCall(rotationPortCall);
    return [...berthCalls, transitBerthCall];
};
